import { render, staticRenderFns } from "./AccordionInfo.vue?vue&type=template&id=3627d52a&scoped=true"
import script from "./AccordionInfo.vue?vue&type=script&lang=js"
export * from "./AccordionInfo.vue?vue&type=script&lang=js"
import style0 from "./AccordionInfo.vue?vue&type=style&index=0&id=3627d52a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3627d52a",
  null
  
)

export default component.exports